export default __webpack_public_path__ + "static/media/first_sailing_holiday.6e3f5169.webp";